import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SystemService } from '../../../services/system.service';
import { Entity } from '../../product/product.model';
import { EntityListComponent } from '../../../components/entity-list/entity-list.component';
import { ICCComponent } from '../../../components/icc/icc.component';
import { InstrumentService } from '../../../components/instrument/instrument.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'icc-page',
    templateUrl: './icc-page.component.html'
})
export class ICCPageComponent implements OnInit, OnDestroy {

    iccList: Entity[];
    icc: any;
    private readonly _unsubscribeAll: Subject<any>;

    @ViewChild('iccForm')
    iccForm: ICCComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;

    constructor(public _systemService: SystemService, public _instrumentService: InstrumentService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {
        this._instrumentService.allIcc$.pipe(
            takeUntil(this._unsubscribeAll),
            tap((data) => {
                this.iccList = data;
            })
        ).subscribe();
    }

    newICC(): void {
        this.icc = null;
        this.iccForm.selected(null);
    }

    selected(entity): void {
        this.icc = entity;
        this.iccForm.selected(entity);
    }

    entityChanged($event: any): void {
        // Actualizar la lista si es necesario
    }
}

